<template>
  <div>
    <DeleteModal
      modalId="modal-consumables-delete"
      @deleteToggle="deleteItem"
    />

    <b-card>
      <div>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>
            {{ $t('surgery.patient-surgery-consumables') }}
          </h2>
          <div>
            <b-button
              variant="primary"
              @click="
                $router.push({
                  name: 'add-patient-surgery-consumables',
                  params: { id: doctorSurgeryId },
                })
              "
              v-if="
                $store.state.app.permissions.includes(
                  'store-patientCardTest'
                ) && !isHistory
              "
            >
              {{ $t('common.add') }} {{ $t('surgery.consumables') }}
            </b-button>
            <b-button
              class="mx-1"
              variant="success"
              @click="printConsumables()"
            >
              {{ $t('common.print') }} {{ $t('surgery.consumables') }}
            </b-button>
          </div>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(price)="data">
            <span class="text-nowrap"> {{ data.item.price }} IQD </span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <!-- @click="printId(data.item.id)" -->
              <!-- <b-button
                v-if="$route.name !== 'active-patient-card'"
                size="sm"
                pill
                variant="outline-primary"
                class="mb-75 mx-1"
                @click="
                  $router.push({
                    name: 'surgery-dispense-consumable',
                    params: {
                      patient_card_id: patientCardId,
                      patient_surgery_id: $route.params.id,
                      id: data.item.item_id,
                      quantity: data.item.quantity,
                    },
                  })
                "
                >{{ $t('surgery.dispense-consumable') }}</b-button
              > -->
              <!-- Dropdown -->
              <ActionsButtons
                v-if="!isHistory"
                :noEdit="true"
                deletePerm="delete-patientCardTest"
                editPerm="delete-patientCardTest"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
                {{ $t('surgery.consumables') }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getPatientSurgeryConsumables()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfMeds"
    >
      <section
        dir="rtl"
        class="pdf-content font-modify m-5 text-dark"
        slot="pdf-content"
      >
        <div dir="rtl" class="container mt-3">
          <div class="container">
            <!-- Row for the first heading -->
            <div class="row">
              <div class="col-12">
                <h4 style="text-align: right">
                  اسم المريض : {{ patientName }}
                </h4>
              </div>
            </div>
            <!-- Row for the second and third headings -->
            <div class="row justify-content-center mt-2">
              <div class="col-auto">
                <h5>صرفيات العملية :</h5>
              </div>
              <div class="col-auto">
                <h5 class="mx-3">رقم الفايل :</h5>
              </div>
            </div>
          </div>

          <table class="border border-0 mt-1">
            <tr>
              <th scope="col">ت</th>
              <th scope="col">المادة</th>
              <th scope="col">العدد</th>
              <th scope="col">السعر</th>
            </tr>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ item.item.name }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.price }}</td>
              </tr>
            </tbody>
          </table>
          <div class="row justify-content-center mt-3">
            <div class="col-auto">
              <h5>الممرضة المسؤولة :</h5>
            </div>
            <div class="col-auto">
              <h5 class="mx-3">مسؤول العمليات :</h5>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import DeleteModal from '@/components/modals/DeleteModal.vue';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
    VueHtml2pdf,
  },

  props: ['patientCardId', 'doctorSurgeryId', 'patientName'],
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: '',
        tests: [],
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        patient_card_id: '',
        tests: [],
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'item.name',
          label: this.$t('surgery.consumable'),
          sortable: true,
        },
        {
          key: 'quantity',
          label: this.$t('common.quantity'),
          sortable: true,
        },

        // { key: 'price', label: this.$t('common.price'), sortable: true },
        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getPatientSurgeryConsumables();
  },
  methods: {
    printConsumables() {
      this.$refs.html2PdfMeds.generatePdf();
    },
    async getPatientSurgeryConsumables() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patientSurgeryConsumable?filter[patient_card_surgery_id]=${this.doctorSurgeryId}&include=item&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.testFilter) {
        url += `&filter[test_id]=${this.testFilter}`;
      }
      if (this.patientFilter) {
        url += `&filter[patient_card_id]=${this.patientFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-consumables-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/patientSurgeryConsumable/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientSurgeryConsumables();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
  },
};
</script>
<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
